import React, { useState, useCallback } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/AffordableOption/Login";
import VehicleSubmission from "./pages/AffordableOption/VehicleSubmission";
import Recommendations from "./pages/AffordableOption/Recommendations";
import Disclosure from "./pages/AffordableOption/Disclosure";
import ContractCreate from "./pages/AffordableOption/ContractCreate";
import ContractSigning from "./pages/AffordableOption/ContractSigning";
import { UserProvider } from "./context/UserContext";

function AffordableOptionApp() {
  const [chosenComponents, setChosenComponents] = useState([]);
  const [currentComponentNames, setCurrentComponentNames] = useState([]);
  const [dealerId, setDealerId] = useState("");
  const [dealers, setDealers] = useState(null);
  const [deductible, setDeductibleState] = useState(null);
  const [vehicle, setVehicle] = useState(null);
  const [mileage, setMileage] = useState("");
  const [rates, setRates] = useState(null);
  const [aiResults, setAiResults] = useState(null);
  const [products, setProducts] = useState(null);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [term, setTermState] = useState(36);
  const [termMileage, setTermMileageState] = useState(30000);
  const [vin, setVin] = useState("");
  const [loadAiRecommendations, setLoadAiRecommendations] = useState(true);
  const [showFullAndWrapPrograms, setShowFullAndWrapPrograms] = useState(true);

  const componentsOrdered = [
    "Powertrain Assembly",
    "Suspension",
    "Brakes",
    "Electrical",
    "Air Conditioning / Heating",
    "Fuel System",
    "Convenience Accessories",
    "Tech",
  ];

  const handleRestart = useCallback(() => {
    setChosenComponents([]);
    setCurrentComponentNames([]);
    setDeductibleState(null);
    setVehicle(null);
    setMileage("");
    setRates(null);
    setAiResults(null);
    setSelectedProgram(null);
    setTermState(36);
    setTermMileageState(30000);
    setVin("");
    setLoadAiRecommendations(true);
    setShowFullAndWrapPrograms(true);
  }, []);

  const setDeductible = useCallback((newDeductible) => {
    setDeductibleState(newDeductible);
  }, []);

  const setTerm = useCallback((newTerm) => {
    setTermState(newTerm);
  }, []);

  const setTermMileage = useCallback((newTermMileage) => {
    setTermMileageState(newTermMileage);
  }, []);

  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <Login
                dealers={dealers}
                setDealers={setDealers}
                dealerId={dealerId}
                setDealerId={setDealerId}
              />
            }
          />
          <Route
            path="/vehicle-submission"
            element={
              <VehicleSubmission
                dealerId={dealerId}
                dealers={dealers}
                handleRestart={handleRestart}
                loadAiRecommendations={loadAiRecommendations}
                mileage={mileage}
                products={products}
                rates={rates}
                setDealerId={setDealerId}
                setDealers={setDealers}
                setLoadAiRecommendations={setLoadAiRecommendations}
                setMileage={setMileage}
                setShowFullAndWrapPrograms={setShowFullAndWrapPrograms}
                showFullAndWrapPrograms={showFullAndWrapPrograms}
                setProducts={setProducts}
                setRates={setRates}
                setVehicle={setVehicle}
                setVin={setVin}
                vin={vin}
              />
            }
          />
          <Route
            path="/recommendations"
            element={
              <Recommendations
                aiResults={aiResults}
                chosenComponents={chosenComponents}
                currentComponentNames={currentComponentNames}
                setCurrentComponentNames={setCurrentComponentNames}
                componentsOrdered={componentsOrdered}
                deductible={deductible}
                handleRestart={handleRestart}
                loadAiRecommendations={loadAiRecommendations}
                mileage={mileage}
                products={products}
                rates={rates}
                selectedProgram={selectedProgram}
                setAiResults={setAiResults}
                setChosenComponents={setChosenComponents}
                setDeductible={setDeductible}
                setSelectedProgram={setSelectedProgram}
                setTerm={setTerm}
                setTermMileage={setTermMileage}
                showFullAndWrapPrograms={showFullAndWrapPrograms}
                term={term}
                termMileage={termMileage}
                vehicle={vehicle}
              />
            }
          />
          <Route
            path="/disclosure"
            element={
              <Disclosure
                chosenComponents={chosenComponents}
                components={componentsOrdered}
                handleRestart={handleRestart}
                mileage={mileage}
                products={products}
                selectedProgram={selectedProgram}
                vehicle={vehicle}
              />
            }
          />
          <Route
            path="/contract-create"
            element={
              <ContractCreate
                chosenComponents={chosenComponents}
                handleRestart={handleRestart}
                mileage={mileage}
                selectedProgram={selectedProgram}
                vehicle={vehicle}
                vin={vin}
              />
            }
          />
          <Route
            path="/contract-signing"
            element={<ContractSigning handleRestart={handleRestart} />}
          />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default AffordableOptionApp;
